import { Grid, Paper, Theme, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react';
import React, { useContext } from 'react';

import { useI18n } from '../../../../../../../application/language/useI18n';
import { ContainerContext } from '../../../../../../../common/container/ContainerContext';
import { ICommonProperties } from '../../../../../../../common/properties/ICommonProperties';
import { ApplicationDetailDomain } from '../../store/ApplicationDetailDomain';

export interface IApplicationInfoDetailsViewProperties extends ICommonProperties {
  domain: ApplicationDetailDomain;
}

export const QuestionnaireVersion = ({ domain }: IApplicationInfoDetailsViewProperties) => {
  return <></>;
};

export const ApplicationInfoDetailsView = observer(({ domain }: IApplicationInfoDetailsViewProperties) => {
  const { translate } = useI18n();
  const classes = useStyles();

  const container = useContext(ContainerContext);
  const ViewModeExtended = container.get(ViewModeLists);
  const QuestionnaireVersionExtended = container.get(QuestionnaireVersion);

  return (
    <Paper className={classes.root} elevation={3}>
      <div className={classes.contentContainer}>
        <QuestionnaireVersionExtended domain={domain} />
        <Grid container direction={'column'} spacing={4} xs={8}>
          {domain.ui.editPerformerTypes.list.length > 1 && (
            <Grid item key="title">
              <Typography variant="h5">{translate('projectPage.typeOfExecutors')}:</Typography>
              <Typography variant="body1">{domain.ui.applicationPerformerType.entity.name}</Typography>
            </Grid>
          )}

          <ViewModeExtended domain={domain} />
          {domain.ui.applicationSpecificationsCategories.list.length === 0 && (
            <Grid item key="empty-specifications">
              <Typography variant="h5">{translate('projectPage.noCharacteristics')}</Typography>
            </Grid>
          )}
        </Grid>
      </div>
    </Paper>
  );
});

export const ViewModeLists = observer(({ domain }: { domain: ApplicationDetailDomain }) => (
  <>
    {domain.ui.applicationSpecificationsCategories.list.map((category) => (
      <Grid item key={category.id}>
        <Typography variant="h5">{category.name}:</Typography>
        <Typography style={{ whiteSpace: 'pre-wrap' }} variant="body1">
          {domain.ui
            .specificationsByCategoryId(category.id)
            .map((specification) => specification.name)
            .join('\n')}
        </Typography>
      </Grid>
    ))}
  </>
));

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    paddingTop: theme.spacing(6),
    paddingLeft: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    paddingRight: 0,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: 'transparent',
  },
  contentContainer: {
    flex: 1,
    overflowY: 'auto',
    minHeight: 0,
    paddingRight: theme.spacing(6),
  },
  centred: {
    display: 'flex',
    alignItems: 'center',
  },
}));
